import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import GiftPackModalStore from './store';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const giftPack = pageLocalesData.main.giftPackModal;

const styles = require('./index.less');

/**
 * 公测礼包弹窗
 */
const GiftPackModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.giftPack)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.content}>
          {/* 展示态  */}
          <div className={styles.showGift}> </div>
          <div className={styles.btnBox}>
            <Link
              className={cx(styles.btn, styles.receive)}
              onClick={() => {
                store.receiveCdk(1);
              }}
            >
              {giftPack.giftPackBtn}
            </Link>
          </div>
        </div>
        {/* 兑换态 */}
        {store.isReceive && (
          <div className={styles.exchangeBox}>
            <div className={styles.title}>{giftPack.title}</div>
            {/* <div className={styles.cdkBox}>
              
            </div> */}
            <div className={styles.cdk}>{store.giftCdk}</div>
            <Link
              className={styles.copyBtn}
              onClick={() => {
                store.copy();
              }}
            >
              {giftPack.copyBtn}
            </Link>

            <div className={styles.tips}>
              {giftPack.tips}
              <br />
              {giftPack.tips2}
            </div>
          </div>
        )}
      </div>
    </ModalContainer>
  );
};

export default wrapStore(GiftPackModal, GiftPackModalStore);
